<template>
  <div class="pages">
    <router-view />

    <cat-loading-cover
      v-if="isLoadingCover"
      :isCat="false"
    />

    <cat-pages-pagination
      v-if="!busy"
      :pagination="pagination"
      :routeName="routeName"
    />

    <b-modal
      id="cat-first-quiz-completed"
      class="basic-modal no-header-modal hide-cancel-btn"
      v-bind:hide-header="true"
      v-bind:ok-title="$t('common.confirm')"
    >
      <div v-html="$t('viewer.page.quiz.completed')"></div>
    </b-modal>

    <CustomModal
      v-if="isNotSupportQuiz"
      id="cat-next-quiz-error-modal"
      class="basic-modal no-header-modal hide-cancel-btn content-report-modal"
      :hide-header="true"
      :ok-title="$t('common.confirm')"
      @ok="handlePageCloseClick"
      :isHideCloseButton="true"
    >
      <div v-html="$t('viewer.cat.page.error')" />
    </CustomModal>

    <CatNoLicenceModal
      :isOpen="isNoLiceceModal || isNoSchoolLicence"
      :isSolvedFreeQuizzes="true"
      :isNoSchoolLicence="isNoSchoolLicence"
      :allowedQuizzesCount="allowedQuizzesCount"
      @onCloseClick="handlePageCloseClick"
    />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { isEmpty } from 'lodash';
import Mobile from '@/mixins/Mobile';
import quiz from '@/mixins/quiz';

import CatLoadingCover from '../components/CatLoadingCover';
import CatPagesPagination from '../components/CatPagesPagination';
import QuizReport from '../../viewer-pages/components/QuizReport';
import CatNoLicenceModal from '../components/CatNoLicenceModal';

export default {
  name: 'cat-page-index',

  data() {
    return {
      isLoadingCover: true,
      isNoLiceceModal: false,
      isNotSupportQuiz: false,
      isNoSchoolLicence: false,
      error: {},
    };
  },

  mixins: [
    Mobile,
    quiz,
  ],

  components: {
    CatLoadingCover,
    CatPagesPagination,
    QuizReport,
    CatNoLicenceModal,
  },

  computed: {
    ...mapGetters({
      cat: 'getCatCard',
      busy: 'getBusy',
      routeName: 'getRouteName',
      routeParams: 'getRouteParams',
      pagination: 'getCatPagesPagination',
      catPages: 'getCatPages',
      catQuizResults: 'getCatQuizResults',
      catQuizWrongResults: 'getCatQuizWrongResults',
      catPagesIdList: 'getCatPagesIdList',
      catPage: 'getCatPage',
      isParentUser: 'isParentUser',
      routeQuery: 'getRouteQuery',
      catQuizResult: 'getCatQuizResult',
      monitoringHistories: 'getMonitoringHistories',
      allowedQuizzesCount: 'getAllowedQuizzesCount',
    }),

    getCatPage() {
      return this.catPages && this.catPages[this.getCatPageId];
    },

    getCatPageId() {
      return this.catQuizResults[this.routeParams.page - 1] &&
          this.catQuizResults[this.routeParams.page - 1].page_id;
    },

    getCatPageIdList() {
      return this.catQuizResults &&
          this.catQuizResults[this.catPagesIdList[this.routeParams.page - 1]];
    },

    childId() {
      return this.routeQuery.child_id;
    },
  },

  methods: {
    ...mapActions({
      fetchCatCard: 'fetchCatCard',
      fetchCatPagesPagination: 'fetchCatPagesPagination',
      fetchResultCatsPage: 'fetchResultCatsPage',
      fetchCatsPage: 'fetchCatsPage',
      setCatQuizResults: 'setCatQuizResults',
      resetSelectedOption: 'resetSelectedOption',
      resetCatQuizStartTime: 'resetCatQuizStartTime',
      fetchMonitoringHistories: 'fetchMonitoringHistories',
      startQuizMonitoring: 'startQuizMonitoring',
      fetchPageQuizResultCache: 'fetchPageQuizResultCache',
      fetchPageAnswerStatistics: 'fetchPageAnswerStatistics',
    }),

    handlePageCloseClick() {
      if (this.isClasstingClient) {
        return this.closeWebview();
      }

      return window.close();
    },

  },

  beforeMount() {
    this.fetchCatCard({ catId: this.routeParams.catId })
      .then((cat) => {
        this.setCatQuizResults({ quizResults: cat.quiz_results });
        return cat;
      })
      .then((cat) => {
        if (
          cat.quiz_results.length > 0
            && isEmpty(this.catQuizWrongResults)
            && !cat.is_completed
        ) {
          this.$root.$emit('bv::show::modal', 'cat-first-quiz-completed');
        }

        if (this.catQuizResults.length < this.routeParams.page) {
          return this.fetchCatsPage({
            ...this.routeParams,
            catPageIdIndex: Number(this.routeParams.page) - 1,
          })
            .then(() => (true))
            .catch((err) => {
              this.error = err;

              if (this.error.status === 402) {
                this.isNoLiceceModal = true;
                return false;
              }

              if (this.error.status === 429) {
                this.isNoSchoolLicence = true;
                return false;
              }

              this.isNotSupportQuiz = true;
              return false;
            });
        }

        // 함수명 변경예정
        return this.fetchResultCatsPage({
          ...this.routeParams,
          catPageId: this.getCatPageId,
        })
          .then((page) => {
            this.fetchPageQuizResultCache({ pageId: page.id });
            return page;
          })
          .then((page) => {
            if (page.page_type.name === 'multiple_choice') {
              return this.fetchPageAnswerStatistics({ pageId: page.id });
            }

            return true;
          });
      })
      .then(() => {
        this.fetchCatPagesPagination({
          total: isEmpty(this.catQuizWrongResults) ?
            this.cat.quiz_count :
            this.catQuizWrongResults.length,
          page: this.routeParams.page,
          prePage: 0,
          quizPosition: 0,
        });
      })
      .then(() => {
        if (!isEmpty(this.error)) return true;
        return this.fetchMonitoringHistories();
      })
      .then(() => {
        if (!isEmpty(this.error)) return true;
        return this.startQuizMonitoring({
          cat: this.cat,
          catPage: this.catPage,
          quizResult: this.catQuizResult,
        });
      })
      .finally(() => {
        this.isLoadingCover = false;
      });
  },

  watch: {
    $route() {
      this.resetCatQuizStartTime();
      this.resetSelectedOption();
      Promise.resolve()
        .then(() => {
          if (this.routeParams.page > this.catQuizResults.length) {
            this.isLoadingCover = true;
            if (isEmpty(this.getCatPagesIdList)) {
              return this.fetchCatsPage({
                ...this.routeParams,
                catPageIdIndex: Number(this.routeParams.page) - 1,
              })
                .then(() => (true))
                .catch((err) => {
                  this.error = err;

                  if (this.error.status === 402) {
                    this.isNoLiceceModal = true;
                    return false;
                  }

                  if (this.error.status === 429) {
                    this.isNoSchoolLicence = true;
                    return false;
                  }

                  this.isNotSupportQuiz = true;
                  return false;
                });
            }
          }

          return this.fetchResultCatsPage({
            ...this.routeParams,
            catPageId: this.getCatPageId,
          })
            .then((page) => {
              this.fetchPageQuizResultCache({ pageId: page.id });
              return page;
            })
            .then((page) => {
              if (page.page_type.name === 'multiple_choice') {
                return this.fetchPageAnswerStatistics({ pageId: page.id });
              }

              return true;
            });
        })
        .then(() => {
          this.fetchCatPagesPagination({
            total: isEmpty(this.catQuizWrongResults) ?
              this.cat.quiz_count :
              this.catQuizWrongResults.length,
            page: this.routeParams.page,
            prePage: 0,
            quizPosition: 0,
          });
        })
        .then(() => {
          if (!isEmpty(this.error)) return true;
          return this.startQuizMonitoring({
            cat: this.cat,
            catPage: this.catPage,
            quizResult: this.catQuizResult,
          });
        })
        .finally(() => {
          this.isLoadingCover = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
  .pages {
    user-select: none;
    background: #ffffff;
    min-height: 100%;
    overflow: auto;
  }
</style>
